// extracted by mini-css-extract-plugin
export var numpadContainer = "_mv-1";
export var phoneButton = "_mv-0";